/* Keep the approved floating placement; only change visibility with scroll direction. */
(() => {
  if (customElements.get('felippa-header-scroll')) return;
  customElements.define('felippa-header-scroll', class extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('[data-site-header]');
      if (!this.header || window.Shopify?.designMode) return;
      this.abort = new AbortController();
      this.last = Math.max(0, scrollY);
      this.distance = 0;
      const signal = this.abort.signal;
      this.setVisible = () => {
        this.header.removeAttribute('data-scroll-hidden');
        this.distance = 0;
      };
      const locked = () => document.body.matches('.js-drawer-open,.js-quick-view-visible,.search-opened') ||
        this.header.matches('.site-header--menu-opened') ||
        !!this.header.querySelector(':focus-visible,[data-nav-item].is-visible');
      const update = () => {
        const y = Math.max(0, Math.min(scrollY, document.documentElement.scrollHeight - innerHeight));
        const delta = y - this.last;
        this.last = y;
        if (y <= this.header.offsetHeight || locked()) return this.setVisible();
        if (!delta) return;
        this.distance = Math.sign(delta) === Math.sign(this.distance) ? this.distance + delta : delta;
        if (this.distance >= 12) this.header.setAttribute('data-scroll-hidden', '');
        if (this.distance <= -6) this.setVisible();
      };
      window.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      }, { passive: true, signal });
      this.header.addEventListener('focusin', this.setVisible, { signal });
      this.observer = new MutationObserver(() => { if (locked()) this.setVisible(); });
      this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.observer.observe(this.header, { attributes: true, attributeFilter: ['class'] });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.header?.removeAttribute('data-scroll-hidden');
    }
  });
})();
